import { useEffect, useRef, useState } from "react";

export default function useCountdown($startAtSeconds:number, $complete:()=>void){
    
    
    const countdownIntervalID = useRef<number>(-1);
    const [curTime, setCurTime] = useState<number>($startAtSeconds);


    const startCountdown=($startAtSeconds?:number)=>{
        if($startAtSeconds){
            setCurTime(()=>{
                return $startAtSeconds;
            })
        }
        resumeCountdown();
    }


    const stopCountdown=()=>{
        if(countdownIntervalID.current){
            window.clearInterval(countdownIntervalID.current);
            countdownIntervalID.current = -1;
        }
    }
    const resumeCountdown=()=>{

        if(countdownIntervalID.current===-1){

            countdownIntervalID.current = window.setInterval(()=>{
                setCurTime(($prev)=>{
                    let nextValue = $prev-1;
                    if(nextValue<=0){
                        nextValue=0;
                        stopCountdown();
                        $complete();
                    }
    
                    return nextValue;
                });
            },1000);
    
        }
    }

    return [curTime, startCountdown, stopCountdown, resumeCountdown] as const;
    
}